import type { PlanFeatureKind } from "@/lib/billing/plan-features";
import {
  IconCpu,
  IconGlobe,
  IconHistory,
  IconLayers,
  IconMemory,
  type IconProps,
  IconUser,
} from "@teral/icons";
import type { ComponentType } from "react";

export const FEATURE_ICONS: Record<PlanFeatureKind, ComponentType<IconProps>> = {
  team: IconUser,
  cpu: IconCpu,
  memory: IconMemory,
  domains: IconGlobe,
  autoscale: IconLayers,
  logs: IconHistory,
};
